
/**
 * Return true if the dragging container is to be dropped on a target container that is a descendant.
 *
 * @param {*} sourceContainerId the dragged container id
 * @param {*} targetContainerId the container id to the drop target
 * @param {*} allContainers the hierarchical tree of all containers including the 'Main Container'.
 */
export const isDescendant = (sourceContainerId, targetContainerId, allContainers) => {

    // Recurse down the container hierarchy looking for a matching id
    const locateContainer = (id, containers) => {

        if (containers) {
            // eslint-disable-next-line no-restricted-syntax
            for (const container of containers) {
                if (container.id === id) {
                    return container;
                }
                const childContainer = locateContainer(id, container.pageContainers);
                if (childContainer) {
                    return childContainer;
                }
            }
        }

        return null;
    };

    // Find the container we are dragging
    const sourceContainer = locateContainer(sourceContainerId, allContainers);
    // See if the target container is a child/grandchild etc. within the source container tree
    let targetContainer = null;
    if (sourceContainer && sourceContainer.pageContainers) {
        targetContainer = locateContainer(targetContainerId, sourceContainer.pageContainers);
    }

    return targetContainer !== null;
};
